import React from 'react';
import c from 'classnames';
import WysiwygField from '../WysiwygField';
import Button from '../Button';
var CallToAction = function CallToAction(_ref) {
  var title = _ref.title,
    text = _ref.text,
    button = _ref.button,
    buttonSecondary = _ref.buttonSecondary,
    _ref$iconClasses = _ref.iconClasses,
    iconClasses = _ref$iconClasses === void 0 ? 'icon-arrow icon-after icon-variant-1' : _ref$iconClasses,
    className = _ref.className;
  var classes = c('CallToAction', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement("h3", {
    className: "CallToAction__title"
  }, title), text && /*#__PURE__*/React.createElement(WysiwygField, {
    className: "CallToAction__text",
    property: "schema:text",
    customElementHandler: function customElementHandler() {},
    html: text
  }), /*#__PURE__*/React.createElement("div", {
    className: "CallToAction__buttonWrapper"
  }, /*#__PURE__*/React.createElement(Button, {
    primary: true,
    className: "CallToAction__button ".concat(iconClasses),
    href: button.link
  }, button.text), buttonSecondary && /*#__PURE__*/React.createElement(Button, {
    inverted: true,
    className: "CallToAction__button ".concat(iconClasses),
    href: buttonSecondary.link
  }, buttonSecondary.text)));
};
export default CallToAction;